module.exports = __webpack_public_path__ + "static/img/icon_01.d339fc77.svg";